import type { CSSProperties } from 'react';

import { useNumberFormatter } from '@mint-lib/formatting-hooks';
import { typographyVariants } from '@mint-lib/tw-components';
import type { TooltipPayload } from 'recharts';

import { formatChartValue, formatLabel } from '../../../helpers/charts.js';
import ChartTooltip from '../ChartTooltip/ChartTooltip.jsx';

type TooltipProps = {
  isActive: boolean;
  contentData: TooltipPayload | undefined;
  xValue: string;
};

const BarChartTooltip = ({ isActive, contentData, xValue }: TooltipProps) => {
  const numberFormatter = useNumberFormatter();

  if (!isActive || !contentData?.length) {
    return null;
  }

  const tooltipHeading = contentData[0].payload[xValue];

  return (
    <ChartTooltip>
      <p
        className={typographyVariants({
          variant: 'caption2',
        })}
      >
        {tooltipHeading}
      </p>
      {contentData.map((data) => (
        <div className="flex flex-row gap-2" key={data.value as number}>
          <div
            style={{ '--bar-tooltipColor': data.color } as CSSProperties}
            className="h-7 w-1 items-center bg-(--bar-tooltipColor)"
          />
          <div className="flex flex-col">
            <p
              className={typographyVariants({
                variant: 'bodyShort01',
              })}
            >
              {formatChartValue({
                numberFormatter,
                value: data.value,
              })}
            </p>
            <p
              className={typographyVariants({
                variant: 'label01',
              })}
            >
              {typeof data.name === 'string'
                ? formatLabel({
                    label: data.name,
                  })
                : data.name}
            </p>
          </div>
        </div>
      ))}
    </ChartTooltip>
  );
};

export default BarChartTooltip;
